import type { State as S } from '../../../../model/State';

export const selectVendorDetails: (state: S, productKey: string) => any = (
  state: S,
  productKey,
) => {
  return state.mac.marketplace.vendorDetails?.[productKey]?.ifSuccess((r) => r);
};
